import './tree-context.scss';
import React, { Component } from 'react';
import Menu, { SubMenu, MenuItem, Divider } from 'rc-menu';
import { Badge } from 'react-bootstrap';
import { Translate } from './../../common/translator.js';
import ContextMenu from './../../context-menu/view/context-menu-view';
import Clipboard from './../../common/clipboard';


export default class TreeContext extends Component{

  _expandNode() {
    this.props.closeContextMenu();

    if (this.props.expandNode) {
      this.props.expandNode(this.props.node);
    }
  }

  _collapseNode() {
    this.props.closeContextMenu();

    if (this.props.collapseNode) {
      this.props.collapseNode(this.props.node);
    }
  }

  _copyUrl() {
    this.props.closeContextMenu();
    Clipboard.copy(this.props.node.idPlant);
  }

  _sendUrlByMail() {
    this.props.closeContextMenu();

    var subject = 'AssetGuide Link';
    var body = window.location.href + '?anleggsid=' + this.props.node.idPlant;
    var uri = 'mailto:?subject=';
    uri += encodeURIComponent(subject);
    uri += '&body=';
    uri += encodeURIComponent(body);
    window.location.href = uri;
  }

  _getModelMenu(itemKey, primBtnTitle, subMenuTitle, isBusy, modelList, modelListLength) {

    var possibleChilds = false;
    if (isBusy) {
      possibleChilds = <MenuItem>Loading...</MenuItem>;
    } else {
      possibleChilds = modelList.map((child, i) => {
        const key = itemKey + i;
        return <MenuItem key={key}>{ (modelListLength !== undefined) ? child.parentName : child.name }</MenuItem>;
      });
    }

    let addChildBtn = null;

    if (modelListLength !== undefined) {
      addChildBtn = <span>{primBtnTitle} <Badge className='contextMenuBadge'>{ (this.props.isFetchingConnectedNodes) ? '...' : modelListLength}</Badge> <i className='fa fa-caret-right fa-fw fa-pull-right'></i></span>;
    } else {
      addChildBtn = <span>{primBtnTitle} <i className='fa fa-caret-right fa-fw fa-pull-right'></i></span>;
    }

    return (
      <SubMenu title={addChildBtn} key={subMenuTitle}>
        <MenuItem disabled={true}>{subMenuTitle}</MenuItem>
        <Divider/>
        { possibleChilds }
      </SubMenu>
    );
  }

  _renderWriteStuctureMenues() {
    if (!this.props.writableStructure) {
      return [
        <Divider key='divided'/>,
        this._getConnectedNodesMenu()
      ];
    } else {
      return [
        <Divider key='divided'/>,
        <MenuItem key='deleteNode'>{Translate('deleteNode')}</MenuItem>,
        this._getAddChildMenu(),
        this._getChangeTypeMenu(),
        this._getConnectedNodesMenu()
      ];
    }
  }



  _itemClicked(clicked) {
    const key = clicked.key;
    if (key === 'collapse') {
      this._collapseNode();
    } else if (key === 'expand') {
      this._expandNode();
    } else if (key === 'copy') {
      this._copyUrl();
    } else if (key === 'sendUrl') {
      this._sendUrlByMail();
    }
  }

  render() {

    return (
      <ContextMenu position={this.props.position} >
        <Menu onClick={this._itemClicked.bind(this)}>
          <MenuItem key='expand'>{Translate('expand')}</MenuItem>
          <MenuItem key='collapse'>{Translate('collapse')}</MenuItem>
          <MenuItem key='copy'>{Translate('copyUrl')}</MenuItem>
          <MenuItem key='sendUrl'>{Translate('sendUrl') + '              '}</MenuItem>
        </Menu>
      </ContextMenu>);
  }
}



/** WEBPACK FOOTER **
 ** app/components/tree-context/view/tree-context.js
 **/